import apiClient from "@/shared/api/apiClient2";

export const getExecInscriptionList = async (params) => {
  try {
    const { data } = await apiClient.get("/exec-inscription", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getExecInscriptionList failed", e);
  }
};

export const getCurrentExecInscriptionList = async (params) => {
  try {
    const { data } = await apiClient.get("/exec-inscription/current", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getCurrentExecInscriptionList failed", e);
  }
};

export const getExecInscriptionItem = async (id) => {
  try {
    const { data } = await apiClient.get(`/exec-inscription/${id}`);
    return data;
  } catch (e) {
    console.error("getExecInscriptionItem failed", e);
  }
};

export const createExecInscription = async (code, params) => {
  const result = await apiClient.post(`/exec-inscription/submit/${code}`, {
    ...params,
  });
  return result.data;
};

export const updateExecInscription = async (id, params, isNotifyDisabled) => {
  const { data } = await apiClient.put(
    `/exec-inscription/${id}`,
    {
      ...params,
    },
    {
      metaData: { isNotificationDisabled: isNotifyDisabled },
    }
  );
  return data;
};

export const changeStatusExecInscription = async (id, params) => {
  const { data } = await apiClient.put(`/exec-inscription/${id}/status`, {
    ...params,
  });
  return data;
};

export const updateExecInscriptionNote = async (id, note) => {
  const { data } = await apiClient.put(`/exec-inscription/${id}/note`, {
    note,
  });
  return data;
};

export const updateExecInscriptionDescription = async (id, description) => {
  const { data } = await apiClient.put(`/exec-inscription/${id}/description`, {
    description,
  });
  return data;
};
